import { useState } from 'react';

const platforms = [
  {
    id: 1,
    name: 'GovEase',
    url: 'govease.com',
    auctionUrl: 'https://www.govease.com/auctions',
    logo: '🏛️',
    description: 'Online tax deed and foreclosure auction platform used by counties across the US.',
    states: ['California', 'Ohio', 'Louisiana', 'Mississippi', 'Nevada', 'New Mexico'],
    stateList: [
      { state: 'Alabama', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Arizona', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'California', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Colorado', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Georgia', schedule: 'Monthly', type: 'Tax Deed' },
      { state: 'Indiana', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Iowa', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Kansas', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Louisiana', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Mississippi', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Oklahoma', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Pennsylvania', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Tennessee', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Texas', schedule: 'Monthly', type: 'Tax Deed' },
      { state: 'Washington', schedule: 'Annual', type: 'Tax Deed' },
    ],
    type: ['Tax Deed', 'Foreclosure'],
    registration: 'Required - create account and complete vesting form per county',
    depositMethod: 'ACH transfer or wire before auction',
    bidding: 'Proxy bidding available',
    fee: 'Buyer premium varies by county (typically 5%)',
    rating: 'A',
    notes: 'Best platform for CA. LA County 2026A auction used GovEase.',
    counties: [
      { state: 'California', county: 'Los Angeles', schedule: 'Annual', nextAuction: '2027 TBD' },
      { state: 'California', county: 'San Diego', schedule: 'Annual', nextAuction: '2026 TBD' },
      { state: 'Ohio', county: 'Lucas County', schedule: 'Weekly Thursdays', nextAuction: '2026-05-07' },
    ]
  },
  {
    id: 2,
    name: 'RealAuction',
    url: 'realauction.com',
    auctionUrl: 'https://www.realauction.com/',
    logo: '⚖️',
    description: 'Major platform for tax deed and tax lien auctions primarily in Florida and other states.',
    states: ['Florida', 'Ohio', 'New Jersey', 'Tennessee', 'West Virginia'],
    stateList: [
      { state: 'Florida', schedule: 'Weekly', type: 'Both' },
      { state: 'Ohio', schedule: 'Weekly', type: 'Tax Deed' },
      { state: 'New Jersey', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Tennessee', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'West Virginia', schedule: 'Annual', type: 'Tax Lien' },
    ],
    type: ['Tax Deed', 'Tax Lien'],
    registration: 'Required per county',
    depositMethod: 'Electronic funds transfer before auction',
    bidding: 'Live online bidding with countdown timer',
    fee: 'Varies by county',
    rating: 'A',
    notes: 'Primary platform for FL tax liens. Each county has its own URL.',
    counties: [
      { state: 'Florida', county: 'Hillsborough', schedule: 'Weekly Thursdays', nextAuction: 'Every Thursday' },
      { state: 'Florida', county: 'Polk', schedule: 'Monthly', nextAuction: 'TBD' },
      { state: 'Ohio', county: 'Lucas County', schedule: 'Weekly', nextAuction: '2026-05-07' },
    ]
  },
  {
    id: 3,
    name: 'Bid4Assets',
    url: 'bid4assets.com',
    auctionUrl: 'https://www.bid4assets.com/mvc/auctions',
    logo: '💰',
    description: 'National online auction platform handling tax deed sales for counties across many states.',
    states: ['Maryland', 'Virginia', 'Washington DC', 'Indiana', 'Michigan', 'Arizona', 'Oregon'],
    stateList: [
      { state: 'Maryland', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Virginia', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Washington DC', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Indiana', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Michigan', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'Arizona', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Oregon', schedule: 'Annual', type: 'Tax Deed' },
      { state: 'California', schedule: 'Annual', type: 'Tax Deed' },
    ],
    type: ['Tax Deed', 'Tax Lien'],
    registration: 'Single account works across all counties',
    depositMethod: 'Credit card or ACH',
    bidding: 'Proxy bidding — set max and platform bids automatically',
    fee: 'Buyer premium of 1.5% or $150 minimum',
    rating: 'B',
    notes: 'Good for Maryland which has 6-month redemption. Single login is convenient.',
    counties: [
      { state: 'Maryland', county: 'Baltimore City', schedule: 'Annual (May)', nextAuction: '2026-05 TBD' },
      { state: 'Maryland', county: 'Prince Georges', schedule: 'Annual', nextAuction: '2026 TBD' },
      { state: 'Indiana', county: 'Marion', schedule: 'Annual (fall)', nextAuction: '2026 Fall TBD' },
    ]
  },
  {
    id: 4,
    name: 'LienHub',
    url: 'lienhub.com',
    auctionUrl: 'https://www.lienhub.com/',
    logo: '🔗',
    description: 'Specialized platform for tax lien certificate auctions primarily in Florida.',
    states: ['Florida'],
    stateList: [
      { state: 'Florida', schedule: 'Annual', type: 'Tax Lien' },
    ],
    type: ['Tax Lien'],
    registration: 'Required — separate registration per county',
    depositMethod: 'Electronic funds transfer',
    bidding: 'Bid down interest rate — minimum 5% floor',
    fee: 'Varies by county',
    rating: 'A',
    notes: 'Florida tax lien specific. 5% minimum penalty floor. Avoid Miami-Dade and Broward.',
    counties: [
      { state: 'Florida', county: 'Polk', schedule: 'Annual (May/June)', nextAuction: '2026 TBD' },
      { state: 'Florida', county: 'Volusia', schedule: 'Annual', nextAuction: '2026 TBD' },
      { state: 'Florida', county: 'Marion', schedule: 'Annual', nextAuction: '2026 TBD' },
    ]
  },
  {
    id: 5,
    name: 'SRI',
    url: 'sri-taxsale.com',
    auctionUrl: 'https://www.sri-taxsale.com/',
    logo: '📋',
    description: 'Tax sale management platform used by counties in the Midwest and Southeast.',
    states: ['Georgia', 'Indiana', 'Kentucky', 'Illinois'],
    stateList: [
      { state: 'Georgia', schedule: 'Monthly', type: 'Tax Deed' },
      { state: 'Indiana', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Kentucky', schedule: 'Annual', type: 'Tax Lien' },
      { state: 'Illinois', schedule: 'Annual', type: 'Tax Lien' },
    ],
    type: ['Tax Deed', 'Tax Lien'],
    registration: 'Required — varies by county',
    depositMethod: 'Varies by county',
    bidding: 'Live auction at courthouse or online depending on county',
    fee: 'Varies',
    rating: 'B',
    notes: 'Georgia first Tuesday auctions often use SRI or direct county websites.',
    counties: [
      { state: 'Georgia', county: 'Gwinnett', schedule: 'First Tuesday Monthly', nextAuction: '2026-06-02' },
      { state: 'Georgia', county: 'Hall', schedule: 'First Tuesday Monthly', nextAuction: '2026-06-02' },
      { state: 'Georgia', county: 'Cherokee', schedule: 'First Tuesday Monthly', nextAuction: '2026-06-02' },
    ]
  },
];

const ratingColors = { 'A': '#c9a84c', 'B': '#2F5496' };
const typeColors = { 'Tax Deed': '#1a1a2e', 'Tax Lien': '#2d6a4f', 'Foreclosure': '#7b2d8b' };

// ── Live Auction Search ──────────────────────────────────────────────────────

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
  'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina',
  'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'Washington DC', 'West Virginia', 'Wisconsin', 'Wyoming',
];

function LiveAuctionSearch() {
  const [state, setState] = useState('California');
  const [county, setCounty] = useState('');
  const [auctionType, setAuctionType] = useState('Any');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [results, setResults] = useState(null);
  const [usage, setUsage] = useState(null);
  const [sessionUsage, setSessionUsage] = useState({ inTok: 0, outTok: 0, webSearches: 0, tokenCost: 0, runs: 0 });

  const search = async () => {
    if (!state) { setError('Please select a state.'); return; }
    const anyState = false;
    setLoading(true);
    setError('');
    setResults(null);
    setUsage(null);

    const today = new Date().toISOString().slice(0, 10);
    const range = (fromDate || toDate)
      ? `Only include auctions scheduled between ${fromDate || today} and ${toDate || 'the next 6 months'}.`
      : `Only include auctions scheduled in the next 6 months (today is ${today}).`;

    const locationLine = anyState
      ? `Location: Nationwide — find upcoming auctions across any US state. Prioritize active investor states (Florida, Georgia, Texas, Maryland, Indiana, Ohio, California, Arizona, New Jersey). Return a spread of states rather than only one.`
      : `Location: ${county ? county + ' County, ' : ''}${state}`;

    const stateField = anyState
      ? `"The state the auction is in"`
      : `"${state}"`;

    const prompt = `You are a tax sale research analyst with web search capability. Use web search to find UPCOMING tax deed and tax lien auctions for the location below. Search official county tax collector / clerk sites and the major platforms (RealAuction, GovEase, Bid4Assets, LienHub, SRI).

${locationLine}
Auction Type: ${auctionType === 'Any' ? 'Tax Deed or Tax Lien' : auctionType}
${range}

After searching, respond ONLY with a JSON object (no markdown, no preamble) in exactly this shape:
{
  "auctions": [
    {
      "county": "County name",
      "state": ${stateField},
      "type": "Tax Deed | Tax Lien",
      "platform": "Platform or site name",
      "auctionDate": "YYYY-MM-DD or best-known description",
      "registrationDeadline": "YYYY-MM-DD or null",
      "url": "direct URL to the auction or registration page",
      "notes": "1 short sentence of useful context"
    }
  ],
  "summary": "1-2 sentence overview of what you found",
  "sources": ["url 1", "url 2"]
}

If you cannot confirm any specific upcoming auctions, return an empty auctions array and explain in summary. Do not invent dates — use "TBD" or null when unknown. Be accurate over comprehensive.`;

    const body = {
      model: 'claude-sonnet-4-5',
      max_tokens: 4000,
      tools: [{ type: 'web_search_20250305', name: 'web_search' }],
      messages: [{ role: 'user', content: prompt }],
    };
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_ANTHROPIC_API_KEY,
      'anthropic-version': '2023-06-01',
      'anthropic-dangerous-direct-browser-access': 'true',
    };

    try {
      let inTok = 0, outTok = 0, webSearches = 0;
      const addUsage = (u) => {
        if (!u) return;
        inTok += u.input_tokens || 0;
        outTok += u.output_tokens || 0;
        if (u.server_tool_use && u.server_tool_use.web_search_requests) {
          webSearches += u.server_tool_use.web_search_requests;
        }
      };

      const response = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST', headers, body: JSON.stringify(body),
      });
      const data = await response.json();
      if (data.error) { setError('API Error: ' + data.error.message); setLoading(false); return; }
      addUsage(data.usage);

      let finalText = '';
      if (data.stop_reason === 'tool_use') {
        const toolResults = data.content
          .filter(block => block.type === 'tool_use')
          .map(block => ({
            type: 'tool_result',
            tool_use_id: block.id,
            content: block.input ? JSON.stringify(block.input) : 'Search completed',
          }));

        const followUp = await fetch('https://api.anthropic.com/v1/messages', {
          method: 'POST', headers,
          body: JSON.stringify({
            ...body,
            messages: [
              { role: 'user', content: prompt },
              { role: 'assistant', content: data.content },
              { role: 'user', content: toolResults },
            ],
          }),
        });
        const followData = await followUp.json();
        if (followData.error) { setError('API Error: ' + followData.error.message); setLoading(false); return; }
        addUsage(followData.usage);
        finalText = followData.content.filter(b => b.type === 'text').map(b => b.text).join('');
      } else {
        finalText = data.content.filter(b => b.type === 'text').map(b => b.text).join('');
      }

      // Sonnet 4.x pricing: $3 / 1M input tokens, $15 / 1M output tokens.
      // Note: web search requests are billed separately and are NOT included here.
      const tokenCost = (inTok / 1e6) * 3 + (outTok / 1e6) * 15;
      setUsage({ inTok, outTok, webSearches, tokenCost });
      setSessionUsage(prev => ({
        inTok: prev.inTok + inTok,
        outTok: prev.outTok + outTok,
        webSearches: prev.webSearches + webSearches,
        tokenCost: prev.tokenCost + tokenCost,
        runs: prev.runs + 1,
      }));

      let clean = finalText.replace(/```json|```/g, '').trim();
      const start = clean.indexOf('{');
      const end = clean.lastIndexOf('}');
      if (start === -1 || end === -1) {
        setError('Could not parse search results. Please try again.');
        setLoading(false);
        return;
      }
      clean = clean.substring(start, end + 1);
      const parsed = JSON.parse(clean);
      setResults(parsed);
    } catch (err) {
      setError('Error running search — please try again. (' + err.message + ')');
    }
    setLoading(false);
  };

  const exportCSV = () => {
    if (!results || !results.auctions || results.auctions.length === 0) return;
    const headers = ['County', 'State', 'Type', 'Platform', 'Auction Date', 'Registration Deadline', 'URL', 'Notes'];
    const esc = (v) => {
      const s = (v === null || v === undefined) ? '' : String(v);
      return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    const rows = results.auctions.map(a => [
      a.county, a.state, a.type, a.platform, a.auctionDate, a.registrationDeadline, a.url, a.notes,
    ].map(esc).join(','));
    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const stamp = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.download = `auction-search-${stamp}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const inputStyle = {
    width: '100%', padding: '9px', border: '1px solid #ddd', borderRadius: '6px',
    fontSize: '13px', boxSizing: 'border-box', marginTop: '4px', backgroundColor: 'white',
  };
  const labelStyle = { fontSize: '12px', color: '#555', fontWeight: 'bold' };

  return (
    <div style={{ marginTop: '24px', padding: '20px', backgroundColor: '#f7faff', borderRadius: '10px', border: '1px solid #d6e2f5' }}>
      <h3 style={{ color: '#2F5496', marginBottom: '4px', fontSize: '17px' }}>🔍 Live Auction Search</h3>
      <p style={{ color: '#555', fontSize: '12px', margin: '0 0 16px' }}>
        Search upcoming tax deed &amp; lien auctions across all platforms by state, county, and date range.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', marginBottom: '14px' }}>
        <div>
          <label style={labelStyle}>State</label>
          <select value={state} onChange={e => setState(e.target.value)} style={inputStyle}>
           
            {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>County <span style={{ fontWeight: 'normal', color: '#999' }}>(optional)</span></label>
          <input value={county} onChange={e => setCounty(e.target.value)} placeholder="e.g. Polk" style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Type</label>
          <select value={auctionType} onChange={e => setAuctionType(e.target.value)} style={inputStyle}>
            <option>Any</option>
            <option>Tax Deed</option>
            <option>Tax Lien</option>
          </select>
        </div>
        <div>
          <label style={labelStyle}>From</label>
          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>To</label>
          <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={inputStyle} />
        </div>
      </div>

      <button
        onClick={search}
        disabled={loading}
        style={{
          backgroundColor: loading ? '#999' : '#2F5496', color: 'white', border: 'none',
          padding: '11px 22px', borderRadius: '6px', cursor: loading ? 'default' : 'pointer',
          fontWeight: 'bold', fontSize: '13px',
        }}
      >
        {loading ? 'Searching the web…' : 'Search Auctions'}
      </button>

      {error && (
        <div style={{ marginTop: '14px', padding: '10px 12px', backgroundColor: '#fdecea', color: '#c0392b', borderRadius: '6px', fontSize: '13px' }}>
          {error}
        </div>
      )}

      {loading && (
        <div style={{ marginTop: '16px', color: '#888', fontSize: '13px' }}>
          Checking county sites and auction platforms… this can take 20–40 seconds.
        </div>
      )}

      {usage && !loading && (
        <div style={{ marginTop: '14px', padding: '10px 12px', backgroundColor: 'white', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '12px', color: '#555' }}>
          <div style={{ marginBottom: '4px' }}>
            <span style={{ fontWeight: 'bold', color: '#2F5496' }}>Last search:</span>{' '}
            {usage.inTok.toLocaleString()} in / {usage.outTok.toLocaleString()} out tokens
            {usage.webSearches > 0 ? ` · ${usage.webSearches} web search${usage.webSearches === 1 ? '' : 'es'}` : ''}
            {' · ~$'}{usage.tokenCost.toFixed(4)} token cost
          </div>
          <div>
            <span style={{ fontWeight: 'bold', color: '#2F5496' }}>Session total ({sessionUsage.runs} run{sessionUsage.runs === 1 ? '' : 's'}):</span>{' '}
            {sessionUsage.inTok.toLocaleString()} in / {sessionUsage.outTok.toLocaleString()} out tokens
            {sessionUsage.webSearches > 0 ? ` · ${sessionUsage.webSearches} web searches` : ''}
            {' · ~$'}{sessionUsage.tokenCost.toFixed(4)} token cost
          </div>
          <div style={{ color: '#aaa', fontSize: '10px', marginTop: '4px' }}>
            Opus $5/$25 per M tokens. Token cost only — excludes web search fees (~$10 per 1,000 searches). Session total resets on page refresh.
          </div>
        </div>
      )}

      {results && (
        <div style={{ marginTop: '18px' }}>
          {results.auctions && results.auctions.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
              <button
                onClick={exportCSV}
                style={{
                  backgroundColor: 'white', color: '#2F5496', border: '1px solid #2F5496',
                  padding: '7px 14px', borderRadius: '6px', cursor: 'pointer',
                  fontWeight: 'bold', fontSize: '12px',
                }}
              >
                ⬇ Export CSV ({results.auctions.length})
              </button>
            </div>
          )}

          {results.summary && (
            <p style={{ fontSize: '13px', color: '#444', backgroundColor: 'white', padding: '10px 12px', borderRadius: '6px', border: '1px solid #eee', margin: '0 0 14px' }}>
              {results.summary}
            </p>
          )}

          {(!results.auctions || results.auctions.length === 0) ? (
            <div style={{ color: '#888', fontSize: '13px' }}>No confirmed upcoming auctions found for this search.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {results.auctions.map((a, i) => (
                <div key={i} style={{ backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '12px 14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '6px' }}>
                    <div>
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{a.county}{a.county && !/county/i.test(a.county) ? ' County' : ''}</span>
                      <span style={{ color: '#888', fontSize: '12px', marginLeft: '6px' }}>{a.state}</span>
                    </div>
                    {a.type && (
                      <span style={{ backgroundColor: typeColors[a.type] || '#888', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '10px' }}>{a.type}</span>
                    )}
                  </div>
                  <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse', marginTop: '8px' }}>
                    <tbody>
                      {[
                        ['Platform', a.platform],
                        ['Auction Date', a.auctionDate],
                        ['Registration By', a.registrationDeadline],
                      ].filter(([, v]) => v && v !== 'null').map(([k, v]) => (
                        <tr key={k}>
                          <td style={{ padding: '3px 8px 3px 0', color: '#888', whiteSpace: 'nowrap', verticalAlign: 'top' }}>{k}</td>
                          <td style={{ padding: '3px 0', color: '#c9a84c', fontWeight: 'bold' }}>{v}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {a.notes && <p style={{ fontSize: '12px', color: '#666', margin: '8px 0 0' }}>{a.notes}</p>}
                  {a.url && (
                    <a href={a.url.startsWith('http') ? a.url : 'https://' + a.url} target="_blank" rel="noopener noreferrer"
                       style={{ display: 'inline-block', marginTop: '8px', fontSize: '12px', color: '#2F5496', fontWeight: 'bold' }}>
                      View auction →
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}

          {results.sources && results.sources.length > 0 && (
            <div style={{ marginTop: '14px', paddingTop: '10px', borderTop: '1px solid #e0e0e0' }}>
              <span style={{ fontSize: '11px', color: '#999' }}>Sources: </span>
              {results.sources.map((src, i) => (
                <a key={i} href={src.startsWith('http') ? src : 'https://' + src} target="_blank" rel="noopener noreferrer"
                   style={{ fontSize: '11px', color: '#2F5496', marginRight: '8px' }}>[{i + 1}]</a>
              ))}
            </div>
          )}

          <p style={{ fontSize: '10px', color: '#aaa', marginTop: '12px' }}>
            Results come from live web search and may be incomplete or out of date. Always confirm dates and deadlines on the official county / platform site before acting.
          </p>
        </div>
      )}
    </div>
  );
}

// ── Static, collapsible, sortable per-platform state list ─────────────────────
function PlatformStates({ platform }) {
  const [open, setOpen] = useState(false);
  const [sortKey, setSortKey] = useState('state');
  const [sortDir, setSortDir] = useState('asc');
  const rows = platform.stateList || [];

  const handleSort = (key) => {
    if (sortKey === key) setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(key); setSortDir('asc'); }
  };

  const sorted = [...rows].sort((a, b) => {
    const av = (a[sortKey] || '').toString().toLowerCase();
    const bv = (b[sortKey] || '').toString().toLowerCase();
    if (av < bv) return sortDir === 'asc' ? -1 : 1;
    if (av > bv) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });

  const arrow = (key) => (sortKey === key ? (sortDir === 'asc' ? ' ▲' : ' ▼') : '');
  const columns = [['state', 'State'], ['schedule', 'Schedule'], ['type', 'Type']];

  return (
    <div style={{ marginTop: '4px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <button
          onClick={() => setOpen(o => !o)}
          style={{
            backgroundColor: '#1a1a2e', color: 'white', border: 'none',
            padding: '8px 14px', borderRadius: '6px', cursor: 'pointer',
            fontWeight: 'bold', fontSize: '12px',
          }}
        >
          {(open ? '▼ States' : '▶ States') + ` (${rows.length})`}
        </button>
        {platform.auctionUrl && (
          <a
            href={platform.auctionUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#2F5496', fontSize: '12px', fontWeight: 'bold', textDecoration: 'none' }}
          >
            Visit {platform.name} auctions →
          </a>
        )}
      </div>

      {open && (
        <div style={{ marginTop: '10px' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f7f7f7', textAlign: 'left' }}>
                  {columns.map(([key, label]) => (
                    <th key={key} onClick={() => handleSort(key)}
                        style={{ padding: '6px 8px', cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
                      {label}{arrow(key)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sorted.map((r, i) => (
                  <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '6px 8px', fontWeight: 'bold' }}>{r.state}</td>
                    <td style={{ padding: '6px 8px', color: '#555' }}>{r.schedule}</td>
                    <td style={{ padding: '6px 8px' }}>
                      {r.type && (
                        <span style={{ backgroundColor: typeColors[r.type] || '#888', color: 'white', padding: '2px 7px', borderRadius: '4px', fontSize: '10px' }}>{r.type}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: '10px', color: '#aaa', marginTop: '8px' }}>
            Participating states change each auction cycle. Use the link above to check {platform.name}'s current list before acting.
          </p>
        </div>
      )}
    </div>
  );
}

function AuctionPlatforms() {
  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <h2 style={{ marginBottom: '4px', fontSize: '20px' }}>Auction Platforms</h2>
        <p style={{ color: '#666', fontSize: '13px', margin: 0 }}>
          Directory of major tax deed and lien auction platforms.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {platforms.map(platform => (
          <div key={platform.id} style={{
            border: '1px solid #ddd', borderRadius: '8px',
            backgroundColor: 'white', boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
            overflow: 'hidden'
          }}>
            {/* Header */}
            <div style={{ backgroundColor: '#1a1a2e', padding: '12px 14px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '22px' }}>{platform.logo}</span>
                  <div>
                    <h3 style={{ margin: 0, fontSize: '16px', color: 'white' }}>{platform.name}</h3>
                    <a href={'https://' + platform.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#c9a84c', textDecoration: 'none' }}>{platform.url}</a>
                  </div>
                </div>
                <span style={{ backgroundColor: ratingColors[platform.rating] || '#888', color: 'white', padding: '3px 9px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold' }}>{platform.rating} Rated</span>
              </div>
              <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                {platform.type.map(t => (
                  <span key={t} style={{ backgroundColor: typeColors[t] || '#888', color: 'white', padding: '2px 7px', borderRadius: '4px', fontSize: '10px' }}>{t}</span>
                ))}
              </div>
            </div>

            {/* Body */}
            <div style={{ padding: '14px' }}>
              <p style={{ fontSize: '13px', color: '#444', marginTop: 0 }}>{platform.description}</p>

              <table style={{ width: '100%', fontSize: '12px', borderCollapse: 'collapse', marginBottom: '10px' }}>
                <tbody>
                  {[
                    ['Registration', platform.registration],
                    ['Deposit', platform.depositMethod],
                    ['Bidding', platform.bidding],
                    ['Fee', platform.fee],
                  ].map(([k, v]) => (
                    <tr key={k}>
                      <td style={{ padding: '4px 12px 4px 0', color: '#888', verticalAlign: 'top', whiteSpace: 'nowrap' }}>{k}</td>
                      <td style={{ padding: '4px 0', color: '#333' }}>{v}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {platform.notes && (
                <div style={{ fontSize: '12px', color: '#777', fontStyle: 'italic', marginBottom: '12px' }}>
                  💡 {platform.notes}
                </div>
              )}

              {/* Live states loader (replaces static counties + states tags) */}
              <PlatformStates platform={platform} />
            </div>
          </div>
        ))}
      </div>

      {/* Live Auction Search */}
      <LiveAuctionSearch />
    </div>
  );
}

export default AuctionPlatforms;
